import React from 'react'
import { MEDIA_BUCKET } from 'config'

const PlayPriceCard = ({ image, price, id = '' }) => {
  return (
    <section
      id="price-panel"
      className="rounded-[10px] bg-white border border-secondary-text p-[30px] flex flex-col justify-center gap-8 items-center shadow-base"
    >
      <p className="text-center font-[650]">{price}</p>
      {image ? (
        <div className="flex justify-center">
          <img src={`${MEDIA_BUCKET}/${image}`} alt="Logo" className="w-full h-full" />
        </div>
      ) : null}
    </section>
  )
}

export default PlayPriceCard
